module.exports = __webpack_public_path__ + "static/img/empty_status.ae6bd331.png";